import { useAtom } from "@reatom/npm-react"

import { Label, Slider, Text } from "ui-kit/components-branded/index"
import { MIN_PRICE, MAX_PRICE } from "modules/PsyProfile/common/constants"
import { priceAtom } from "modules/PsyCatalog/common/models/filterForm"

export function PriceSelector() {
    const [[priceFrom, priceTo]] = useAtom(priceAtom.inputValue)
    return (
        <>
            <div style={{ overflow: "auto" }}>
                <Label htmlFor="price-range-slider" className="label-with-opacity is-inline-block">
                    Цена
                </Label>
                <Text className="price-range-text">
                    {priceFrom} – {priceTo}
                </Text>
            </div>
            <Slider
                min={MIN_PRICE}
                max={MAX_PRICE}
                step={500}
                range={true}
                defaultValue={[priceFrom, priceTo]}
                onChange={priceAtom.onChange}
                value={[priceFrom, priceTo]}
            />
        </>
    )
}
